import { gql } from "@apollo/client";

export const CHANNEL_FIELDS = gql`
    fragment ChannelFields on ChannelType {
        id
        channelName
        companyName
        companyAddress
        contactName
        contactPhone
        email
        taxRate
        taxId
        isAutoGenerate
        isSetSettlementConfig
        settlementCustomerType
        settlementTrackingPoint
        billingCycleConfiguration
        weightCalculationMode
        weightCalculationThresholdX
        settlementMode
        billType
        billUnitType
        timeZoneIana
        schemeLimitNode
        status
        remark
        createdAt
        updatedAt
    }
`;

export interface ChannelType {
    id?: string;
    channelName: string;
    companyName: string;
    companyAddress?: string;
    contactName?: string;
    contactPhone?: string;
    email?: string;
    taxRate?: string;
    taxId?: string;
    isAutoGenerate: boolean;
    isSetSettlementConfig: boolean;
    settlementCustomerType: number;
    settlementTrackingPoint: string | null;
    billingCycleConfiguration: number;
    weightCalculationMode: number;
    weightCalculationThresholdX?: number;
    settlementMode: number;
    billType: number[];
    billUnitType: number;
    timeZoneIana?: string;
    schemeLimitNode?: string;
    status: number;
    remark?: string;
    createdAt?: string;
    updatedAt?: string;
} 